import { responseError } from '@/utils/errors';
import { assignIfExists } from '@/utils/resultsHelper';
import { states } from '@/constants/lifecycle';
import withDraft from '@/utils/draftHelper';
import actions from '../constants';
import findDataset from '../../state/shared';

const fetchDatasetLinks = withDraft((draft, action) => {
  const item = findDataset(draft, action);

  assignIfExists(item.customActions, {
    readStatus: states.PENDING,
    readErrors: [],
  });
});
const fetchDatasetLinksSuccess = withDraft((draft, action) => {
  const item = findDataset(draft, action);

  assignIfExists(item.customActions, {
    readStatus: states.SUCCESS,
    readErrors: [],
    ...action.result,
  });
});
const fetchDatasetLinksError = withDraft((draft, action) => {
  const item = findDataset(draft, action);
  assignIfExists(item.customActions, {
    readStatus: states.ERROR,
    readErrors: [responseError(action)],
  });
});

export default {
  [actions.FETCH_DATASET_LINKS]: fetchDatasetLinks,
  [actions.FETCH_DATASET_LINKS_ERROR]: fetchDatasetLinksError,
  [actions.FETCH_DATASET_LINKS_SUCCESS]: fetchDatasetLinksSuccess,
};
